<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Board Member Occupations</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="draggableList.startAdd()">
        <mat-icon>add</mat-icon>
        Add Board Member Occupation
      </button>
    </div>
  </div>
  <div>
    <app-draggable-list
      #draggableList
      [items]="items()"
      [displayProperty]="'name'"
      [showEdit]="true"
      [showDelete]="true"
      (itemsReordered)="onItemsReordered($event)"
      (editItem)="onEditItem($event)"
      (deleteItem)="onDeleteItem($event)"
      (dragStarted)="onDragStarted($event)"
      (dragMoved)="onDragMoved($event)"
      (dragEnded)="onDragEnded($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-draggable-list>
  </div>
</div>
